import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';

export interface Color {
  id: string;
  name: string;
  approvedRecipeNumber?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class LabDipRequestProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/lab-dip-request';

  public getColorsByIds(colorIds: string[]): Observable<ApiResponse<Color[]>> {
    return this.httpClient.post<ApiResponse<Color[]>>(`${this.baseUrl}/by-color/batch/ids`, colorIds);
  }
}
